export const DEFAULT_LOCALE = 'ua';
export const NO_DATA_PLACEHOLDER = '-';
export const ALL_ITEMS = 'ALL';

export const LOCALES = {
  RU: 'ru',
  EN: 'en',
  UA: 'ua',
} as const;

export const NAME_SPACES = [
  'button',
  'column',
  'common',
  'email',
  'error',
  'field',
  'image',
  'landing',
  'link',
  'message',
  'modal',
  'page',
  'text',
] as const;

export type NameSpace = (typeof NAME_SPACES)[number];
export type Locale = (typeof LOCALES)[keyof typeof LOCALES];
